// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-product-container {
    max-width: 1100px;
    margin: 40px auto;
    padding: 30px;
    /* background: #ffffff; */
    border-radius: 12px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
    font-family: "Segoe UI", sans-serif;
    box-sizing: border-box; /* ✅ overflow fix */
    overflow: hidden; /* ✅ content ko container ke andar rakhta hai */
  }
  
  .add-product-container h2 {
    text-align: center;
    margin-bottom: 30px;
    font-size: 28px;
    color: #333;
    font-weight: 600;
  }
  
  .form-section {
    /* margin-bottom: 30px; */
    padding: 15px 20px;
    /* background: #1e293b; */
    border-radius: 10px;
    box-sizing: border-box;
    width: 100%;
  }
  
  .form-section h3 {
    font-size: 18px;
    margin-bottom: 15px;
    color: #e5dcdc;
    border-left: 4px solid #facc15;
    padding-left: 8px;
    font-weight: 500;
  }
  
  .form-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr); /* ✅ 3 fields per row */
    gap: 18px;
    box-sizing: border-box;
  }
  
  @media (max-width: 992px) {
    .form-grid {
      grid-template-columns: repeat(2, 1fr); /* ✅ Tablet view - 2 fields per row */
    }
  }
  
  @media (max-width: 600px) {
    .form-grid {
      grid-template-columns: 1fr; /* ✅ Mobile view - single column */
    }
  }
  
  .add-product-form input,
  .add-product-form textarea {
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 14px;
    font-family: "Segoe UI", sans-serif; /* ✅ input jaise hi font */
    width: 100%;
    box-sizing: border-box;
    transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  }
  
  
  .add-product-form input:focus,
  .add-product-form textarea:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);
    outline: none;
  }
  
  .add-product-form textarea {
    min-height: 80px;
    resize: vertical;
    line-height: 1.5; /* ✅ text readable lage */
  }
  
  .checkbox-label {
    display: inline-flex; /* ✅ text ke saath line me */
    align-items: center;
    gap: 6px; /* ✅ checkbox aur text ke beech thoda gap */
    font-size: 14px;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
  }
  
  .checkbox-label input[type="checkbox"] {
    width: 16px;
    height: 16px;
    accent-color: #007bff; /* ✅ modern browsers me blue checkbox */
    cursor: pointer;
  }
  
  
  .image-upload-box,
  .video-upload-box {
    margin: 15px 0;
    padding: 20px;
    border: 2px dashed #aaa;
    border-radius: 10px;
    text-align: center;
    cursor: pointer;
    transition: background 0.2s ease-in-out;
    box-sizing: border-box;
    width: 100%;
  }
  
  .image-upload-box:hover,
  .video-upload-box:hover {
    background: #f1f5f9;
  }
  
  .preview-image {
    max-width: 150px;
    margin-bottom: 10px;
    border-radius: 10px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  
  .button-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    width: 100%;
    box-sizing: border-box;
  }
  
  .submit-btn {
    background: #007bff;
    color: #fff;
    border: none;
    padding: 10px 16px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.2s ease-in-out, transform 0.1s ease-in-out;
  }
  
  .submit-btn:hover {
    background: #0056b3;
    transform: translateY(-1px);
  }
  
  .submit-btn:active {
    transform: translateY(1px);
  }
  
  
  .add-product-form label {
    display: block;
    font-size: 12px; /* chota font size */
    font-weight: 500;
    color: #555;
    margin-bottom: 4px; /* thoda gap input ke upar */
  }
  
  .checkbox-label {
    font-size: 12px; /* chota font size */
    gap: 6px;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }


.description-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 10px;
}

.description-box {
  width: calc(50% - 10px);
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.description-box label {
  font-weight: 500;
  margin-bottom: 5px;
}

.description-box textarea {
  width: 100%;
  height: 100px;
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  resize: vertical;
}

.form-actions1 {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}

.cancel-btn {
  background: #6b7280;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
}

.cancel-btn:hover {
  background: #4b5563;
}`, "",{"version":3,"sources":["webpack://./src/pages/Products/EditProduct/EditProduct.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,mCAAmC;IACnC,sBAAsB,EAAE,mBAAmB;IAC3C,gBAAgB,EAAE,+CAA+C;EACnE;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,qCAAqC,EAAE,uBAAuB;IAC9D,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE;MACE,qCAAqC,EAAE,qCAAqC;IAC9E;EACF;;EAEA;IACE;MACE,0BAA0B,EAAE,kCAAkC;IAChE;EACF;;EAEA;;IAEE,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,mCAAmC,EAAE,0BAA0B;IAC/D,WAAW;IACX,sBAAsB;IACtB,sEAAsE;EACxE;;;EAGA;;IAEE,qBAAqB;IACrB,4CAA4C;IAC5C,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB,EAAE,yBAAyB;EAC7C;;EAEA;IACE,oBAAoB,EAAE,4BAA4B;IAClD,mBAAmB;IACnB,QAAQ,EAAE,2CAA2C;IACrD,eAAe;IACf,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB,EAAE,uCAAuC;IAC9D,eAAe;EACjB;;;EAGA;;IAEE,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,uCAAuC;IACvC,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,mEAAmE;EACrE;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,cAAc;IACd,eAAe,EAAE,oBAAoB;IACrC,gBAAgB;IAChB,WAAW;IACX,kBAAkB,EAAE,4BAA4B;EAClD;;EAEA;IACE,eAAe,EAAE,oBAAoB;IACrC,QAAQ;IACR,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;EACjB;;;AAGF;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".add-product-container {\n    max-width: 1100px;\n    margin: 40px auto;\n    padding: 30px;\n    /* background: #ffffff; */\n    border-radius: 12px;\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);\n    font-family: \"Segoe UI\", sans-serif;\n    box-sizing: border-box; /* ✅ overflow fix */\n    overflow: hidden; /* ✅ content ko container ke andar rakhta hai */\n  }\n  \n  .add-product-container h2 {\n    text-align: center;\n    margin-bottom: 30px;\n    font-size: 28px;\n    color: #333;\n    font-weight: 600;\n  }\n  \n  .form-section {\n    /* margin-bottom: 30px; */\n    padding: 15px 20px;\n    /* background: #1e293b; */\n    border-radius: 10px;\n    box-sizing: border-box;\n    width: 100%;\n  }\n  \n  .form-section h3 {\n    font-size: 18px;\n    margin-bottom: 15px;\n    color: #e5dcdc;\n    border-left: 4px solid #facc15;\n    padding-left: 8px;\n    font-weight: 500;\n  }\n  \n  .form-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr); /* ✅ 3 fields per row */\n    gap: 18px;\n    box-sizing: border-box;\n  }\n  \n  @media (max-width: 992px) {\n    .form-grid {\n      grid-template-columns: repeat(2, 1fr); /* ✅ Tablet view - 2 fields per row */\n    }\n  }\n  \n  @media (max-width: 600px) {\n    .form-grid {\n      grid-template-columns: 1fr; /* ✅ Mobile view - single column */\n    }\n  }\n  \n  .add-product-form input,\n  .add-product-form textarea {\n    padding: 10px 12px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    font-size: 14px;\n    font-family: \"Segoe UI\", sans-serif; /* ✅ input jaise hi font */\n    width: 100%;\n    box-sizing: border-box;\n    transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n  }\n  \n  \n  .add-product-form input:focus,\n  .add-product-form textarea:focus {\n    border-color: #007bff;\n    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);\n    outline: none;\n  }\n  \n  .add-product-form textarea {\n    min-height: 80px;\n    resize: vertical;\n    line-height: 1.5; /* ✅ text readable lage */\n  }\n  \n  .checkbox-label {\n    display: inline-flex; /* ✅ text ke saath line me */\n    align-items: center;\n    gap: 6px; /* ✅ checkbox aur text ke beech thoda gap */\n    font-size: 14px;\n    cursor: pointer;\n    user-select: none;\n  }\n  \n  .checkbox-label input[type=\"checkbox\"] {\n    width: 16px;\n    height: 16px;\n    accent-color: #007bff; /* ✅ modern browsers me blue checkbox */\n    cursor: pointer;\n  }\n  \n  \n  .image-upload-box,\n  .video-upload-box {\n    margin: 15px 0;\n    padding: 20px;\n    border: 2px dashed #aaa;\n    border-radius: 10px;\n    text-align: center;\n    cursor: pointer;\n    transition: background 0.2s ease-in-out;\n    box-sizing: border-box;\n    width: 100%;\n  }\n  \n  .image-upload-box:hover,\n  .video-upload-box:hover {\n    background: #f1f5f9;\n  }\n  \n  .preview-image {\n    max-width: 150px;\n    margin-bottom: 10px;\n    border-radius: 10px;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  \n  .button-container {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 20px;\n    width: 100%;\n    box-sizing: border-box;\n  }\n  \n  .submit-btn {\n    background: #007bff;\n    color: #fff;\n    border: none;\n    padding: 10px 16px;\n    border-radius: 6px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: background 0.2s ease-in-out, transform 0.1s ease-in-out;\n  }\n  \n  .submit-btn:hover {\n    background: #0056b3;\n    transform: translateY(-1px);\n  }\n  \n  .submit-btn:active {\n    transform: translateY(1px);\n  }\n  \n  \n  .add-product-form label {\n    display: block;\n    font-size: 12px; /* chota font size */\n    font-weight: 500;\n    color: #555;\n    margin-bottom: 4px; /* thoda gap input ke upar */\n  }\n  \n  .checkbox-label {\n    font-size: 12px; /* chota font size */\n    gap: 6px;\n    display: inline-flex;\n    align-items: center;\n    cursor: pointer;\n  }\n\n\n.description-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-top: 10px;\n}\n\n.description-box {\n  width: calc(50% - 10px);\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n}\n\n.description-box label {\n  font-weight: 500;\n  margin-bottom: 5px;\n}\n\n.description-box textarea {\n  width: 100%;\n  height: 100px;\n  padding: 8px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  resize: vertical;\n}\n\n.form-actions1 {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.cancel-btn {\n  background: #6b7280;\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.cancel-btn:hover {\n  background: #4b5563;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
